import React, { useState } from "react"
import { faEllipsis } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, Menu, MenuItem } from "@mui/material"
import { SurveyQuestion } from "../merchantSurveyTypes"

// TODO: need to change any
interface ActionMenuItem {
    text: string
    onClick: (item: any) => void
}

interface ActionMenuProps {
    item: SurveyQuestion
    menuItems: ActionMenuItem[]
}

export const ActionMenu = ({ item, menuItems }: ActionMenuProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls={`long-test-${item.id}`}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <FontAwesomeIcon icon={faEllipsis} />
            </IconButton>
            {anchorEl && (
                <Menu
                    id={`long-test-${item.id}`}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {menuItems.map((menuItem, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                menuItem.onClick(item)
                                handleClose()
                            }}
                        >
                            {menuItem.text}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </div>
    )
}
